import { Injectable, NgZone } from '@angular/core';
import { NgbModal, NgbActiveModal, NgbModalRef, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';

@Injectable()
export class ModalService {

  modalRef: NgbModalRef;
  constructor(private modal: NgbModal, private ngZone: NgZone) {

  }

  create<T>(component:any, modalOptions: NgbModalOptions = {}): ModalWindow<T> {

    const defaultOptions: NgbModalOptions = {
      backdrop: 'static'
    };
    let newOptions = { ...defaultOptions, ...modalOptions }; //override defaultOptions
    let ref: NgbModalRef;
    this.ngZone.run(() => {  //wrapt it in this call so angular is aware of the change inside boostrap modal
      ref = this.modal.open(component, newOptions);
    })

    return new ModalWindow<T>(ref.componentInstance, ref);
  }
  openModal<T>(component: any): T {
    const options: NgbModalOptions = {
      // size: 'lg'
      backdrop: 'static'
    };
    this.modalRef = this.modal.open(component, options);
    return this.modalRef.componentInstance;
  }
  closeModal() {
    this.modalRef.close();
  }
}


export class ModalWindow<T>{
  constructor(public component: T, public modalRef:NgbModalRef) {}
}
